export interface NotificationsSummary {
    totalUnread: number;
    totalHighPriority: number;
    totalCritical: number;
    lastNotificationDate: string | null;
    recentNotifications: NotificationItem[];
}

export interface NotificationsSummaryResponse {
    data: NotificationsSummary;
    errors: string[];
    warnings: string[];
    success: boolean;
    isFailure: boolean;
    hasWarnings: boolean;
}

export interface NotificationItem {
    id: number;
    userId: number;
    userRole?: number;
    type?: number;
    priority: number;
    title: string;
    message: string;
    actionUrl: string | null;
    expiresAt: string | null;
    isRead: boolean;
    status: number;
    createdAt: string;
    updatedAt: string;
    readAt: string | null;
    dismissedAt: string | null;
    isExpired: boolean;
    taskId?: number | null;
}

export enum NotificationPriority {
    LOW = 0,
    MEDIUM = 1,
    HIGH = 2,
    CRITICAL = 3
}

export enum NotificationStatus {
    UNREAD = 0,
    READ = 1,
    DISMISSED = 2,
    ARCHIVED = 3
}

export interface NotificationsListFilters {
    status?: NotificationStatus | null;
}
